import { useEffect } from "react";

export type SignalHandler<T, U> = (...params: T[]) => U;

export class Signal<T, U> {
    private handlers: SignalHandler<T, U>[] = [];

    add(handler: SignalHandler<T, U>) {
        if (this.handlers.includes(handler)) {
            return;
        }
        this.handlers.push(handler);
    }

    remove(handler: SignalHandler<T, U>) {
        const index = this.handlers.indexOf(handler);
        if (index > -1) {
            this.handlers.splice(index, 1);
        }
    }

    dispatch(...params: T[]): U[] {
        return this.handlers.map((handler) => handler(...params));
    }
}

export function useSignal<T, U>(signal: Signal<T, U>, handler: SignalHandler<T, U>) {
    useEffect(() => {
        signal.add(handler);
        return () => signal.remove(handler);
    }, [signal, handler]);
}
